'use client';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import { Box } from '@wanteddev/wds-engine';
import { forwardRef, useRef } from 'react';
import { textFieldWrapperStyle } from './style.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

var TextField = forwardRef(
  ({ invalid, rightIcon, className, style, sx, xs, sm, md, lg, xl, ...props }, ref) => {
    const inputRef = useRef(null);
    const composedRefs = useComposedRefs(inputRef, ref);
    return /* @__PURE__ */ jsxs(
      Box,
      {
        className,
        style,
        sx: [
          textFieldWrapperStyle({
            invalid,
            xs,
            sm,
            md,
            lg,
            xl,
            ...props
          }),
          sx
        ],
        onPointerDown: (event) => {
          const target = event.target;
          if (target.closest("input, button, a"))
            return;
          const input = inputRef.current;
          if (!input)
            return;
          requestAnimationFrame(() => {
            input.focus();
          });
        },
        children: [
          /* @__PURE__ */ jsx("input", { ref: composedRefs, "aria-invalid": invalid, ...props }),
          rightIcon
        ]
      }
    );
  }
);
TextField.displayName = "TextField";
var text_field_default = TextField;

export { text_field_default as default };
